import type { MouseEvent } from 'react';

import SaveAlt from '@mui/icons-material/SaveAlt';

import WidgetButton from '@/shared/ui/primitives/WidgetButton';

const ExportButton = ({
  title,
  disabled,
  handleClick
}: {
  title: string;
  disabled?: boolean;
  handleClick: (event: MouseEvent) => void;
}) => (
  <WidgetButton
    disabled={disabled}
    icon={<SaveAlt sx={{ fontSize: 16 }} />}
    title={title}
    onClick={handleClick}
  />
);

export default ExportButton;
